<script setup>
import { renderRichText } from "@storyblok/vue";

defineProps({ blok: Object });
</script>

<template>
  <div v-html="renderRichText(blok.pageBody)" class="richtext" />
</template>
